import { Injectable } from '@angular/core';
import JSEncrypt from 'jsencrypt';

@Injectable({
  providedIn: 'root'
})
export class RSAService {

  public encryptWithPublicKey(data: string, publicKeyXml: string): string {
    const encryptor = new JSEncrypt();
    encryptor.setPublicKey(this.convertXmlToPem(publicKeyXml));
    return encryptor.encrypt(data) as string;
  }
 
  private convertXmlToPem(xmlKey: string): string {
    return xmlKey; // jsencrypt supports XML directly
  }
}


 